import type AccountProviderInfo from '../store/schema/AccountProviderInfo';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { AccountProviderType } from 'owa-accounts-store';
import {
    getAccountProviderTypeIcon,
    getAccountProviderTypeExtendedLabel,
} from 'owa-accounts-utils';
import { startAddingAccount } from '../actions/internalActions';

export default function getAccountProviders(): AccountProviderInfo[] {
    const outlookProvider = createProviderInfo('Outlook');
    const googleProvider = createProviderInfo('Google');
    const iCloudProvider = createProviderInfo('ICloud');
    let providers = [outlookProvider];
    if (isFeatureEnabled('cal-addCalendar-google')) {
        providers.push(googleProvider);
    }
    if (isFeatureEnabled('cal-addCalendar-iCloud')) {
        providers.push(iCloudProvider);
    }
    return providers;
}

function createProviderInfo(accountProviderType?: AccountProviderType): AccountProviderInfo {
    return {
        accountProviderType: accountProviderType,
        label: getAccountProviderTypeExtendedLabel(accountProviderType),
        icon: getAccountProviderTypeIcon(accountProviderType),
        onClick: startAddingAccount,
    };
}
